import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const StepOverSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default StepOverSVG;
